import React, { useEffect, useState } from "react";

import axios from "axios";

import { useTranslation } from "react-i18next";
import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function Button({ className, text, color, textcolor }) {

    const { t } = useTranslation();

    const { link } = useContext(LinkContext);

    return (
        <div className={className}>
            <a href={link}>
                <div
                    className="button_main flex cursor-pointer"
                    style={{ backgroundColor: color }}
                >
                    <p
                        className="uppercase roboto font-[500] text-[16px]"
                        style={{ color: textcolor }}
                    >
                        {text}
                    </p>
                </div>
            </a>
        </div>
    );
}

export default Button;
